<app-partner-view></app-partner-view>
